import UserModel from 'src/models/UserModel';
import { client } from './httpClient';
import { getRequestProperties } from './subscriptionsAPI';

export const createFreeTrialSubscription = async (user: UserModel): Promise<boolean> => {
  try {
    const { headers } = user.getApiV3ReqOpts();
    const { baseURL } = await getRequestProperties();

    const path = baseURL + '/free-trials';
    const body = {
      duration: 7
    };

    await client.post(path, body, { headers });

    return true;
  } catch (e) {
    return false;
  }
};
